import CategoryForm from '../../components/Forms/CategoryForm';
import { invalidUrlError, validateUrl } from '../../utils/functions';

const JobForm = ({ functionality }) => {
  const category = 'job';
  const fields = [
    { name: 'title', label: 'Job Title', type: 'text', required: true },
    { name: 'company', label: 'Employer/Organization', type: 'text', required: true },
    {
      name: 'organization_url',
      label: 'Organization URL',
      type: 'text',
      pattern: validateUrl,
      title: invalidUrlError,
      required: true,
      placeholder: 'https://www.amazon.com/careers',
    },
    {
      name: 'job_type',
      label: 'Job Type',
      type: 'select',
      drop_down: true,
      options: [
        { value: 'Full-time', label: 'Full-time' },
        { value: 'Part-time', label: 'Part-time' },
        { value: 'Internship', label: 'Internship' },
        { value: 'Contract', label: 'Contract' },
        { value: 'Temporary', label: 'Temporary' },
        { value: 'Volunteer', label: 'Volunteer' },
      ],
    },
    { name: 'location', label: 'Location', type: 'text' },
    {
      name: 'workplace_type',
      label: 'Workplace Type',
      type: 'select',
      drop_down: true,
      options: [
        { value: 'On-site', label: 'On-site' },
        { value: 'Hybrid', label: 'Hybrid' },
        { value: 'Remote', label: 'Remote' },
      ],
    },
    {
      name: 'application_link',
      label: 'Application Link',
      type: 'text',
      pattern: validateUrl,
      title: invalidUrlError,
      required: true,
      placeholder: 'https://www.amazon.jobs/en/',
    },
    {
      name: 'description',
      label: 'Job Description',
      type: 'text',
      required: true,
      text_area: true,
      rows: '12',
    },
    {
      name: 'required_qualifications',
      label: 'Required Qualifications',
      type: 'text',
      required: true,
      text_area: true,
      rows: '8',
      placeholder: 'Including work authorizations',
    },
    {
      name: 'application_deadline',
      label: 'Application Deadline',
      type: 'date',
      //required: true
    },
    { name: 'posting_date', label: 'Job Posting Date', type: 'date' },
    {
      name: 'preferred_qualifications',
      label: 'Preferred Qualifications',
      type: 'text',
      text_area: true,
      rows: '8',
    },
    {
      name: 'salary',
      label: 'Salary/Compensation',
      type: 'text',
      placeholder: '$120,000 - $150,000',
    },
    { name: 'benefits', label: 'Benefits', type: 'text', text_area: true, rows: '8' },
    { name: 'image_url', label: 'Organization Logo', type: 'image' },
  ];

  return <CategoryForm functionality={functionality} category={category} fields={fields} />;
};
export default JobForm;
